'use strict';

define(['underscore',
//'./config/RouteConfig',
'edge/quoteandbind/ho/config/RouteConfig', 'text!edge/quoteandbind/common/config/metadata/QuestionSets.json', 'edge/quoteandbind/ho/directives/HOConfirmation', 'edge/quoteandbind/ho/directives/HOUpgrade', 'edge/quoteandbind/ho/directives/HOSelectWithOther', 'edge/quoteandbind/ho/directives/HORoofTypeSelect', 'edge/quoteandbind/ho/directives/HOTypelistRadios', 'edge/quoteandbind/ho/directives/HOEditScheduledProperty', 'edge/quoteandbind/ho/directives/HOEditBlanketItems', 'edge/quoteandbind/ho/directives/HOEditCoverages', 'edge/quoteandbind/ho/directives/HOViewCoverages', './config/ScheduledPropertiesExpressionValidation', 'edge/quoteandbind/common/app', 'edge/platform/el/module', 'angularRouter'], function (_, RouteConfig, QuestionSets, HOConfirmation, HOUpgrade, HOSelectWithOther, HORoofTypeSelect, HOTypelistRadios, HOEditScheduledProperty, HOEditBlanketItems, HOEditCoverages, HOViewCoverages, scheduledPropValidation) {
    var questionSets = JSON.parse(QuestionSets);

    return angular.module('edge.quoteandbind.ho.app', ['edge.quoteandbind.common.app', 'edge.platform.el']).constant('HOConstants', {
        POLICY_TYPE_ID: 'HO3'
    }).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
        var states = new RouteConfig(RootStateConfig);
        for (var stateName in states) {
            if (states.hasOwnProperty(stateName)) {
                $stateProvider.state(stateName, states[stateName]);
            }
        }
    }]).config(['QuestionSetServiceProvider', function (QuestionSetServiceProvider) {
        QuestionSetServiceProvider.addQuestionSets(questionSets);
    }]).filter('orderObjectBy', function () {
        return function (items, field, reverse) {
            var filtered = [];
            angular.forEach(items, function (item) {
                filtered.push(item);
            });
            filtered.sort(function (a, b) {
                /*eslint-disable */
                return a[field] > b[field] ? 1 : a[field] < b[field] ? -1 : 0;
                /*eslint-enable */
            });
            if (reverse) {
                filtered.reverse();
            }
            return filtered;
        };
    }).directive('gwHoConfirmation', HOConfirmation).directive('gwHoUpgrade', HOUpgrade).directive('gwHoSelectWithOther', HOSelectWithOther).directive('gwHoRoofTypeSelect', HORoofTypeSelect).directive('gwHoTypelistRadios', HOTypelistRadios).directive('gwQnbHoEditScheduledProperty', HOEditScheduledProperty).directive('gwQnbHoEditBlanketItems', HOEditBlanketItems).directive('gwQnbHoEditCoverages', HOEditCoverages).directive('gwQnbHoViewCoverages', HOViewCoverages).run(['ExpressionLanguageService', function (ExpressionLanguage) {
        ExpressionLanguage.getCompilationContext('pc').registerType('edge.capabilities.quote.lob.homeowners.quoting.internal.HOQuoteUtilities', scheduledPropValidation);
    }]);
});


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=ho!./common/js/src/edge/quoteandbind/ho/app.js
 ** module id = 746
 ** module chunks = 0
 **/